import { Map, fromJS } from 'immutable';
import type { Offer } from 'src/types/offer/Offer';
import type { Trip } from 'src/types/trips/Trips';

// Actions
const SET_OFFER = 'offer/offer/SET_OFFER';
const PATCH_OFFER = 'offer/offer/PATCH_OFFER';
const CLEAR_OFFER = 'offer/offer/CLEAR_OFFER';
const CLEAR_FIELDS = 'offer/offer/CLEAR_FIELDS';

// Reducer
// eslint-disable-next-line @typescript-eslint/default-param-last
export default function offerReducer(state = Map(), action) {
  switch (action.type) {
    case SET_OFFER:
      // Merge might be more appropriate.
      // Do I really just want to return the whole thing?
      return state.merge(action.offer);
    case PATCH_OFFER:
      return state.merge(fromJS(action.fields));
    case CLEAR_OFFER:
      return Map();
    case CLEAR_FIELDS:
      return state.filter((value, field) => !action.fields.includes(field));
    default:
      return state;
  }
}

// Basic action creators
export const setOffer = offer => ({ type: SET_OFFER, offer });
export const patchOffer = (fields: Partial<Offer>) => ({ type: PATCH_OFFER, fields });
export const clearOffer = () => ({ type: CLEAR_OFFER });
export const clearFields = (
  fields: (keyof Offer | keyof Trip)[],
) => ({ type: CLEAR_FIELDS, fields });
